import { VK_OPENAPI_SRC } from '../config'
import type { VkPostEmbedParams } from '../types'

export function buildVkPostCode({
  element_id,
  owner_id,
  post_id,
  hash,
}: VkPostEmbedParams) {
  return `
    <div id="${element_id}"></div>
    <script type="text/javascript" src="${VK_OPENAPI_SRC}"></script>
    <script type="text/javascript">
      (function() {
          VK.Widgets.Post("${element_id}", ${owner_id}, ${post_id}, '${hash}');
      }());
    </script>
  `
}
